const StatisticsSchema = {
  title: 'Statistics (Semantic UI)',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [
        'horizontal', 
        'inverted', 
        'size',
        'items'
      ],
    },
  ],

  properties: {
    horizontal: {
      title: 'Horizontal',
      type: 'boolean',
      description: 'Displays content horizontally',
      default: false,
    },

    inverted: {
      title: 'Inverted',
      type: 'boolean',
      description: 'Displays content with inverted colors',
      default: false,
    },

    size: {
      title: 'Size',
      type: 'string',
      choices: [
        ['mini', 'Mini'],
        ['tiny', 'Tiny'],
        ['small', 'Small'],
        ['large', 'Large'],
        ['huge', 'Huge'],
      ],
      default: 'small'
    },

    items: {
      title: 'Statistics',
      widget: 'object_list',
      schema: {
        title: 'Statistic',
        fieldsets: [
          {
            id: 'default',
            title: 'Default',
            fields: ['value', 'label', 'icon', 'image', 'color'],
          },
        ],
        properties: {
          value: {
            title: 'Value',
            type: 'string',
          },

          label: {
            title: 'Label',
            type: 'string',
          },

        color: {
            title: 'Color',
            type: 'string',
            choices: [
              ['red', 'Red'],
              ['orange', 'Orange'],
              ['yellow', 'Yellow'],
              ['olive', 'Olive'],
              ['green', 'Green'],
              ['teal', 'Teal'],
              ['blue', 'Blue'],
              ['violet', 'Violet'],
              ['purple', 'Purple'],
              ['pink', 'Pink'],
              ['brown', 'Brown'],
              ['grey', 'Grey'],
            ],
          },

          icon: {
            title: 'Icon',
            type: 'string',
            description: 'Accepts any Semantic UI icon name',
          },

          image: {
            title: 'Image',
            type: 'string',
            widget: 'image',
          },
        },
      },
    },
  },

  required: ['items'],
};

export default StatisticsSchema;
